module.exports = __webpack_public_path__ + "img/visao.fa871cad.jpg";